export enum eEntityOperation {
    UNKNOWN = -1,
    CRE_DEFAULT,
    RET_DEFAULT,
    UPD_DEFAULT,
    DEL_DEFAULT,
    ANALISIS_CLIENTE,
    UPD_UpdateClienteMuerto,
    CRE_ClienteEspecifico,
    UPD_AnimalEspecifico,

    //USUARIO
    RET_USUARIO_BY_NUMUSUARIO,
    RET_LAST_USUARIO,
    UPD_USUARIO_BY_ID,
    DEL_USUARIO_BY_ID,
    CRE_USUARIO,
    RET_USUARIOS,
    RET_USUARIOS_BY_CONDITION,

    //QUEUE
    //catalog
    RET_QUEUE,
    RET_QUEUE_BY_ID,
    RET_ENABLE_QUEUE,
    RET_QUEUE_BY_FILTER,
    UPD_QUEUE_BY_ID,
    UPD_QUEUE_QTY,
    DEL_QUEUE_BY_ID,
    CRE_QU_CATALOG,

    //process
    RET_QU_PROCESS_BY_FILTER,
    RET_QU_PROCESS_BY_ID,
    RET_QU_PROCESS,
    RET_QU_PROCESS_MISS_MATCH,
    UPD_QU_PROCESS_BY_ID,
    CRE_QU_PROCESS,
    DEL_QU_PROCESS_BY_ID,
    UPD_QU_PRIORITY,

    //qu_enc_queue
    RET_QU_ENC_QUEUE_BY_ID,
    RET_QU_ENC_QUEUE_FILTER,
    RET_QU_ENC_RUNNING_PROCESS,
    DEL_QU_ENC_QUEUE,
    CRE_QU_ENC_QUEUE,
    RET_QU_ENC_BY_STATUS,

    UPD_QU_ENC_BY_ID,
    UPD_QU_ENC_QUEUE,
    UPD_STATUS_ENC_QUEUE,
    UPD_PRIORITY_ENC_QUEUE,
    UPD_QUEUE_ID_ENC_QUEUE,
    UPD_EXEC_STATUS_ENC_QUEUE,

    //qu_miss_match
    RET_QU_MISS_MATCH_BY_PROCESS_ID,
    RET_QU_MISS_MATCH_BY_ID,
    UPD_QU_MISS_MATCH_PROCESS_BY_ID,
    DEL_QU_MISS_MATCH_BY_ID,

    //qu_parameters
    RET_QU_PARAMETER_BY_PROCESS_ID,
    UPD_QU_PARAMETER_BY_ID,
    DEL_QU_PARAMETER_BY_ID,

    //qu_det_queue
    RET_QU_DET_QUEUE_BY_PROCESS_ID,

    RET_QU_CATALOG_SERVICES,

    //QU_HISTORICAL
    RET_HISTORICAL,
    RET_HISTORICAL_BY_PROCESS,
    UPD_HISTORICAL_BY_PROCESS,
    DEL_HISTORICAL_BY_PROCESS,
    CRE_HISTORICAL,

    //QU_LOG
    RET_QUEUE_LOG,

    //FILE LOG
    RET_FILE_LOG_CONDITION,

    //DIGITALIZACION
    //EXPEDIENTES
    RET_EXPEDIENTE_CONDITION,
    RET_EXPEDIENTE_BY_ID,
    CRE_EXPEDIENTE,
    UPD_EXPEDIENTE,
    DEL_EXPEDIENTE,

    //DOCUMENTOS
    RET_DOCUMENTOS_BY_EXPEDIENTE,
    RET_DOCUMENTO_BY_ID,
    UPD_TIPO_DOCUMENTO,

    //CLIENTES
    RET_ClienteByID,
    CRE_ClienteEspecifico_HARD_CODE,
    RET_ClientesPorNombre_ORDER_BY,
    RET_CLIENTE_BY_TIP_PROVEEDOR,
    RET_NOM_CLIENTE_BY_NUMCLIENTE,
    RET_LST_CLIENTES,
    RET_CLIENTE_BY_ID_POR_DESIGNADOS,
    RET_TODOS_CLIENTES_POR_CEDULA,
    RET_LIST_CLIENTE_BY_NOM_APELLIDOS,

    //STYLE_FORMATS
    CRE_STYLE_FORMATS,
    UPD_STYLE_FORMATS,
    DEL_STYLE_FORMATS,
    RET_STYLE_FORMATS,
    RET_STYLE_FORMATS_BY_CONDITION,

    //USERS
    RET_USER_BY_ID,
    RET_USERS,
    RET_USERS_BY_FILTERS,
    RET_USERS_BY_USER_CODE,
    RET_EMAIL_PASS_BY_CODE,
    UPD_USER_BY_ID,
    UPD_USER_LOCKED,
    UPD_PASS_BY_ID,
    DEL_USER_BY_ID,
    CRE_USER,
    UPD_LAST_LOGON_BY_ID,
    UPD_MODIFICAR_LOGIN_FAILURES,
    RET_USER_BY_NUM_CLIENTE,
    RET_USER_CREDENTIALS_BY_NUM_CLIENTE,
    UPD_LAST_LOGON_AUTH_BY_ID,
    RET_USERS_TECNICO,
    RET_LIST_ALL_USERS,

    //USAGES
    RET_OPERATION,
    RET_TOP_OPERATIONS,

    //MENU
    RET_MENU_OPTIONS_BY_USER,
    RET_PARENT_ELEMENTS,
    RET_MENU_OPTION,

    //DUAL
    RET_VTABLE_SEQ,
    RET_CONF_BASE_SEQ,
    RET_INVENTARIO_SEQ,
    RET_DOCUMENTO_SEQ,

    //MESSAGES
    RET_MESSAGE_BY_APP,
    RET_MESSAGES,
    RET_MESSAGES_BY_ID,
    UPD_MESSAGE_BY_ID,
    DEL_MESSAGE_BY_ID,
    RET_MESSAGE_EXISTS,
    RET_MESSAGE_BY_DATE,

    //ROLES
    RET_ROLES,
    RET_ALL_ROLES,
    RET_USER_ROLE,
    UPD_ROLE_BY_ID,
    DEL_ROLE_BY_ID,
    RET_ROLE_BY_CODE,

    //MENU_OPTIONS
    RET_MENU_OPTIONS,
    UPD_MENU_OPTION_BY_ID,
    DEL_MENU_OPTION_BY_ID,

    //ROLES_USERS
    RET_ROLES_BY_USER_ID,
    RET_USER_ROLE_BY_CODE,
    CRE_USER_ROLE,
    DEL_USER_ROLE_BY_ID,

    //LIST_OPTIONS
    RET_LIST_OPTIONS,
    RET_LIST_BY_LIST_VALUE,
    RET_LIST_ALL,
    RET_LIST_BY_CODE,
    UPD_LIST_BY_ID,
    DEL_LIST_BY_ID,
    RET_CODE_FIELD,
    RET_PROPERTY,
    RET_LST_STATIC_OPTIONS,
    RET_LST_STATIC_OPTIONS_DESC,
    RET_LIST_CATALOG,
    CRE_LST_CATALOG_PF,
    RET_LIST_CATALOG_ALL,
    DEL_LST_CATALOG,
    UPD_LST_CATALOG,
    RET_LIST_CATALOGO_BY_STATIC_LOV,
    RET_LIST_CATALOG_BY_CODE,
    RET_LIST_CATALOG_BY_LSTCODE,
    RET_LIST_NOT_ZABBIX,

    //dynamic
    RET_LST_ANALISTAS_SISTEMAS,
    //VIEWS
    RET_ALL_VIEWS,
    RET_VIEW_BY_UNIQUE,
    UPD_VIEW_BY_ID,
    DEL_VIEW_BY_ID,

    //RULES
    RET_ALL_RULES,
    INSERT_NEW_RULE,
    DEL_RULE_BY_ID,
    UPD_RULE_BY_ID,
    UPD_QTY_ITEMS_BY_ID,
    RET_COUNT_ITEMS,

    //ITEMS
    RET_ITEMS_BY_RULE_ID,
    DEL_ITEM_BY_KEYS,
    RET_MAX_ITEM_ID,
    RET_ITEMS_BY_ITEM_NAME,
    UPD_ITEM_BY_KEYS,

    //ECOMMERCE
    RET_ALL_TRANSACTION_CATALOG,
    UPD_TRANSACTION_CATALOG,
    DEL_TRANSACTION_CATALOG,
    RET_TRANSACTION_CATALOG_BY_ID,

    //CONFIG_BASE (AFL)
    RET_CONFIG_BASE,
    RET_CONFIG_BASE_BY_ID,
    RET_CONFIG_BASE_WITH_CATEGORY,
    CRE_CONFIG_BASE,
    UPD_CONFIG_BASE,
    DEL_CONFIG_BASE,
    RET_CONSULTA,

    //TABLA (AFL)
    RET_TABLAS,
    RET_TABLA_BY_ID,
    RET_TABLA_BY_NOMBRE,
    UPD_TABLA_BY_ID,
    DEL_TABLA_BY_ID,
    CRE_TABLA,

    //PARAMETRO (AFL)
    RET_PARAMETROS,

    //CONDICIONES (AFL)
    RET_CONDICIONES,
    UPD_CONDICION,

    //DET_CONFIG (AFL)
    UPD_IND_DESP,

    //COLUMNAS (AFL)
    RET_COLUMNAS,
    RET_COLUMNA_BY_NOMBRE,
    UPD_COLUMNA_BY_ID,
    DEL_COLUMNA_BY_ID,
    CRE_COLUMNA,

    //MENU_GROUP
    UPD_MENU_GROUP_BY_ID,
    DEL_MENU_GROUP_BY_ID,
    RET_ALL_MENU_GROUP,


    //FUNCIONES (AFL)
    RET_FUNCIONES,
    RET_FUNCION_BY_NOMBRE,
    RET_FUNCIONES_TABLA,
    UPD_FUNCION_BY_ID,
    DEL_FUNCION_BY_ID,
    CRE_FUNCION,

    //OPERADORES (AFL)
    RET_OPERADORES,
    RET_OPERADOR_BY_NOMBRE,
    UPD_OPERADOR_BY_ID,
    DEL_OPERADOR_BY_ID,
    CRE_OPERADOR,

    //PLANT_ENCUESTA (AFL)
    RET_PLANT_ENCUESTA,
    RET_PLANT_ENCUESTA_BY_NOMBRE,
    UPD_PLANT_ENCUESTA,
    DEL_PLANT_ENCUESTA,

    //ENC_POBLACION (AFL)
    RET_ENC_POBLACION,

    //CATALOGO_CAMPAÑA
    RET_CATALOG,
    UPD_CATALOG,
    DEL_CATALOG,

    //OPERATION_USG
    RET_OPERATION_USG,
    RET_TOP_OPERATION_LESS,
    RET_TOP_OPERATION_MOST,

    //OPERATION_LOG
    RET_OPERATIONS_OF_BEHAVIOR,
    //RET_OPERATIONS_FOR_BEHAVIOR,

    //CATALOGO TABLAS VIRTUALES 
    RET_CAT_TABLAS_VIRTUALES,
    RET_CAT_TABLA_VIRTUAL_BY_ID,
    UPD_CAT_TABLA_VIRTUAL_BY_ID,
    DEL_CAT_TABLA_VIRTUAL_BY_ID,
    CRE_CAT_TABLA_VIRTUAL,

    //REPORTES
    RET_REPORT_BY_NAME,
    RET_REPORTS,
    RET_REPORT_BY_CODE,
    UPD_REPORT_BY_ID,
    DEL_REPORT_BY_ID,
    CRE_REPORT,
    RET_REPORT_BY_CODE_REPORT,

    //BEHAVIOR
    RET_BEHAVIOR_BY_ID,
    RET_BEHAVIOR_BY_FILTER,

    //VIEW_REPORT
    RET_VIEWS_REPORT_BY_ID_REPORT,
    DEL_VIEW_REPORT_BY_ID,
    RET_VIEW_REPORT_BY_ID,

    //PARAMETER
    RET_PARAMETERS,
    RET_PARAMETER_BY_REPORTID,
    RET_PARAMETER_BY_NAME,
    UPD_PARAMETER_BY_ID,
    DEL_PARAMETER_BY_ID,

    //AUDITORIAS 
    RET_AUDITS,
    RET_AUDITS_BY_ID,

    //CFG_VIEW_PARAMS
    UPD_CFG_VIEW_PARAMS_BY_ID,
    DEL_CFG_VIEW_PARAMS_BY_ID,

    //OPTION_GROUP
    RET_ROLES_MENU_OPTION_EXIST,
    DEL_OPTION_FROM_GROUP,

    //REPORT LOG
    RET_REPORT_LOG_BY_FILTER,
    RET_REPORT_LOG_BY_ID,
    RET_PENDING_LOG_BY_USER,

    // COMMUNICATION_LOG
    RET_COMMUNICATION_LOG_BY_FILTER,
    RET_COMMUNICATION_LOG_BY_ID,

    //GROUP_ROLE
    RET_GROUP_ROLE_EXIST,
    DEL_GROUP_ROLE,

    //SIGMAIL
    RET_SERVICES,
    RET_SHIPMENT_DETAILS_SMS_BY_ID,
    RET_SHIPMENT_DETAILS_SMS_BY_ID_TEST,
    RET_MAX_CODE,
    UPD_SERVICE,
    RET_SERVICE_DESCRIPTION,
    RET_REQ_APROBACION,
    RET_SHIPMENT_BY_ID,
    RET_SERVICE_BY_ID,
    UPD_GROUP_SHIPMENT_STATE_BY_ID,
    RET_SERVICESS_BY_SERCH,

    //LISTAS DE ENVIO
    RET_LIST_BY_FILTER,
    UPD_SENDING_LIST,
    RET_LIST_DETAIL,
    UPD_DETAIL_LIST,
    DEL_DETAIL,
    DEL_LIST,
    CRE_DETAIL,

    //DETALLE ENVIO SIGMAIL
    RET_LEIDOS,
    RET_ENVIADOS,
    RET_FALLIDOS,
    RET_PENDIENTES,
    UPD_SHIPMENT_STATE_BY_ID,
    RET_SHIPMENT_DETAILS_BY_STATUS,
    RET_SHIPMENT_DETAILS_BY_NUMCLIENTE,
    RET_DETAIL_STATISTICS,
    RET_SHIPMENT_DETAILS,
    RET_CLIENT_BY_FILTER,
    RET_SMS_STATISTICS,

    //SYS PARAMS
    RET_SYS_PARAMS_BY_IDCOMP,
    RET_SYS_PARAMS_BY_ID,
    UPD_SYS_PARAMS_BY_ID,
    DEL_SYS_PARAMS_BY_ID,

    //AFL PLANT PREGUNTA 
    RET_PLANT_PREGUNTA,
    RET_PLANT_PREGUNTA_BY_NOMBRE,
    UPD_PLANT_PREGUNTA,
    DEL_PLANT_PREGUNTA,

    //AFL PLANT RESPUESTA
    RET_PLANT_RESPUESTA,
    UPD_PLANT_RESPUESTA,
    DEL_PLANT_RESPUESTA,

    //AFL LOCALIZACION CLIENTES
    UPD_LOCALIZACION_BY_ID,
    RET_LOCALIZACIONES,
    DEL_LOCALIZACION_BY_ID,
    CRE_LOCALIZACION,
    RET_LOCALIZACION_BY_ID,
    RET_LOCALIZACIONES_EMAIL,

    //AFL CLIENTES
    RET_CLIENTE_BY_ID,
    UPD_CLIENTE_BY_ID,
    DEL_CLIENTE_BY_ID,
    CRE_CLIENTE,
    RET_CLIENTES,
    RET_CLIENTE_BY_NUMCLIENTE,

    //AFL DIRECCION CLIENTES
    RET_DIRECCION_BY_ID,
    UPD_DIRECCION_BY_ID,
    DEL_DIRECCION_BY_ID,
    RET_DIRECCION_BY_DES_UBICACION,
    CRE_DIRECCION,


    //AFL TERRITORIAL CLIENTES
    RET_PROVINCIAS,
    RET_CANTONES_BY_PROVINCIA,
    RET_DISTRITOS_BY_CANTON,
    RET_ALL_CANTONES,
    RET_ALL_DISTRITOS,


    RET_LST_P1C0D0,
    RET_LST_P2C0D0,
    RET_LST_P3C0D0,
    RET_LST_P4C0D0,
    RET_LST_P5C0D0,
    RET_LST_P6C0D0,
    RET_LST_P7C0D0,

    RET_LST_P0C0D0,
    RET_LST_P0C1D1,
    RET_LST_P0C1D0,
    RET_LST_P1C1D0,
    RET_LST_P1C2D0,
    RET_LST_P1C3D0,
    RET_LST_P1C4D0,
    RET_LST_P1C5D0,
    RET_LST_P1C6D0,
    RET_LST_P1C7D0,
    RET_LST_P1C8D0,
    RET_LST_P1C9D0,
    RET_LST_P1C10D0,
    RET_LST_P1C11D0,
    RET_LST_P1C12D0,
    RET_LST_P1C13D0,
    RET_LST_P1C14D0,
    RET_LST_P1C15D0,
    RET_LST_P1C16D0,
    RET_LST_P1C17D0,
    RET_LST_P1C18D0,
    RET_LST_P1C19D0,
    RET_LST_P1C20D0,
    RET_LST_P2C1D0,
    RET_LST_P2C2D0,
    RET_LST_P2C3D0,
    RET_LST_P2C4D0,
    RET_LST_P2C5D0,
    RET_LST_P2C6D0,
    RET_LST_P2C7D0,
    RET_LST_P2C8D0,
    RET_LST_P2C9D0,
    RET_LST_P2C10D0,
    RET_LST_P2C11D0,
    RET_LST_P2C12D0,
    RET_LST_P2C13D0,
    RET_LST_P2C14D0,
    RET_LST_P2C15D0,
    RET_LST_P3C1D0,
    RET_LST_P3C2D0,
    RET_LST_P3C3D0,
    RET_LST_P3C4D0,
    RET_LST_P3C5D0,
    RET_LST_P3C6D0,
    RET_LST_P3C7D0,
    RET_LST_P3C8D0,
    RET_LST_P4C1D0,
    RET_LST_P4C2D0,
    RET_LST_P4C3D0,
    RET_LST_P4C4D0,
    RET_LST_P4C5D0,
    RET_LST_P4C6D0,
    RET_LST_P4C7D0,
    RET_LST_P4C8D0,
    RET_LST_P4C9D0,
    RET_LST_P4C10D0,
    RET_LST_P5C1D0,
    RET_LST_P5C2D0,
    RET_LST_P5C3D0,
    RET_LST_P5C4D0,
    RET_LST_P5C5D0,
    RET_LST_P5C6D0,
    RET_LST_P5C7D0,
    RET_LST_P5C8D0,
    RET_LST_P5C9D0,
    RET_LST_P5C10D0,
    RET_LST_P5C11D0,
    RET_LST_P6C1D0,
    RET_LST_P6C2D0,
    RET_LST_P6C3D0,
    RET_LST_P6C4D0,
    RET_LST_P6C5D0,
    RET_LST_P6C6D0,
    RET_LST_P6C7D0,
    RET_LST_P6C8D0,
    RET_LST_P6C9D0,
    RET_LST_P6C10D0,
    RET_LST_P6C11D0,
    RET_LST_P7C1D0,
    RET_LST_P7C2D0,
    RET_LST_P7C3D0,
    RET_LST_P7C4D0,
    RET_LST_P7C5D0,
    RET_LST_P7C6D0,

    RET_LST_PROVINCIAS,
    RET_LST_CANTONES,

    //POBLACION
    RET_POBLACIONES_BY_IDPOBLACION,
    RET_POBLACION_XLS,

    //ENC POBLACION
    RET_ENC_POBLACION_BY_FILTER,
    DEL_ENC_POBLACION_BY_ID,
    UPD_ENC_POBLACION_TO_EXPIRE,

    //ENCUESTA
    RET_POBLACION_BY_ID_ENCUESTA,
    RET_POBLACION_BY_ID_ENCUESTA_BY_FILTRO,
    RET_USER_RESULT,
    RET_SUMMARY_RESULT,
    RET_COUNT_ENCUESTAS_ASIGNADAS,
    UPD_ESTADO_BY_ID,
    UPD_ESTADO_FINISH_BY_ID,
    UPD_USUARIO_RESPONSABLE,

    //ENCUESTA HISTORICO
    RET_ENCUESTA_HIST_BY_ID,
    CRE_ENCUESTA_HIST,
    RET_MAX_ITEM_HIST_BY_ID,

    //RESPUESTA
    RET_RESPUESTAS_BY_ID_PREGUNTA,
    SER_UPD_RESPONSABLES_ASIGNADOS,

    //EMPLEADO
    RET_EMPLEADO,
    UPD_EMPLEADO,
    UPD_EMPLEADO_EDAD,
    DEL_EMPLEADO,

    //ROLES_MENU_OPTIONS
    RET_ROLES_MENU_OPTION,
    UPD_ROLES_MENU_OPTION,
    DEL_ROLES_MENU_OPTION,

    //FAMILIA
    RET_FAMILIA,
    RET_FAMILIA_BY_DESC,
    UPD_FAMILIA,
    DEL_FAMILIA,
    CRE_FAMILIA,
    RET_FAMILIA_NUM_CONSECUTIVO,
    RET_MAX_CODE_FAMILIA,
    RET_ALL_FAMILIAS,
    RET_ALL_FAMILIAS_OR,


    //CATEGORIA
    RET_CATEGORIA,
    RET_CATEGORIA_BY_FAMILIA,
    RET_CATEGORIA_BY_DES,
    UPD_CATEGORIA,
    DEL_CATEGORIA,
    RET_CATEGORIAS,
    RET_CATEGORIAS_OR,


    //CAMPAÑA
    RET_CAMPANNA_BY_ID,
    UPD_CAMPANNA_BY_ID,
    DEL_CAMPANNA_BY_ID,

    //AGENTES AFL
    RET_AGENTES,
    UPD_AGENTE_BY_ID_USR,
    DEL_AGENTE_BY_ID_USR,
    RET_AGENTE_BY_ID_USR,

    //CAMPANNA_PENDIENTES
    RET_CAMP_PENDIENTES_BY_ID,

    //LIST 
    RET_MAX_LIST_ID,

    //MAESTRO DE ACTIVOS
    RET_ACTIVOS,
    UPD_ACTIVO_BY_ID,
    DEL_ACTIVO_BY_ID,
    RET_ACTIVO_BY_NUM_ACTIVO,
    CRE_ACTIVO,
    RET_ACTIVOS_BY_CATEGORIA,
    RET_ACTIVOS_BY_MARCA,
    RET_ACTIVOS_BY_UBICACION,
    RET_LST_ACTIVOS,

    //DEPARTAMENTO 
    RET_DEPARTAMENTO,
    RET_ALL_DEPARTAMENTOS,
    RET_ALL_DEPARTAMENTOS_OR,
    RET_ALL_DEPARTAMENTOS_IN,
    RET_DEPTOS_BY_USERCODE,
    CRE_DEPARTAMENTO,
    RET_DEPARTAMENTO_POR_FILTROS,
    RET_DEPARTAMENTO_ES_DIR,
    RET_TODOS_DEPARTAMENTOS,
    UPD_DEPARTAMENTO,
    DEL_DEPARTAMENTO,
    RET_TODOS_DEPARTAMENTOS_POR_ESTADO,
    RET_TODOS_DEPARTAMENTOS_POR_EMPRESA_SSVMN,
    RET_TODOS_DEPARTAMENTOS_POR_EMPRESA_SM,
    RET_TODOS_DEPTO_DIR_POR_EMPRESA_SSVMN,
    RET_TODOS_DEPTO_DIR_POR_EMPRESA_SM,
    RET_TODOS_DEPTO_BY_NUM_CLIENTE,
    RET_DESC_DEPTO_BY_NUM_CLIENTE,
    RET_DESC_DEPTO,
    RET_TODOS_DEPARTAMENTOS_ACTIVOS,

    //EMPLEADOS_DEPTO
    RET_EMPLEADOS_DEPTO,
    DEL_EMPLEADOS_DEPTO,
    CRE_EMPLEADOS_DEPTO,
    RET_EMPLEADO_DEPTO_BY_ID,
    //DB_ACCESS        
    RET_HISTORY,

    //CATALOGO DE TRAMITES SERV
    RET_CAT_CONCEPTOS_BY_COD_CONCEPTO,

    //HIST_DEPRECIACION
    RET_HIST_OPERATION,

    //conceptos para categorias de activos
    RET_CONCEPTOS,

    //TRALADOS DE ACTIVOS
    RET_TRASLADOS,
    RET_TRASLADO_BY_DESC,
    UPD_TRASLADO,
    DEL_TRASLADO,
    CRE_TRASLADO,

    //FILE STORAGE
    RET_FSI_BY_ID,
    RET_FSI_BY_OWNER_ID,

    //HIST TRASLADOS
    RET_HIST_TRASLADO,
    DEL_HIST_TRASLADO,
    CRE_HIST_TRASLADO,
    UPD_HIST_TRASLADO,

    //ACTIVOS POR TRASLADO
    RET_ACTIVOS_TRASLADOS_BY_ID,
    RET_ACTIVOS_TRASLADOS_BY_ID_TRASLADO,
    DEL_ACTIVOS_TRASLADOS_BY_ID,
    CRE_ACTIVOS_TRASLADO,

    //EXCLUSIONES
    RET_EXCLUSIONES,
    RET_EXCLUSIONES_BY_DESC,
    UPD_EXCLUSION,
    DEL_EXCLUSION,
    CRE_EXCLUSION,

    //INVENTARIO 
    RET_INVENTARIOS,
    RET_INVENTARIO_BY_ID,
    CRE_INVENTARIO,
    RET_INVENTARIO_BY_DEPTO,
    RET_INVENTARIO_DET_BY_NUM_ACTIVO,
    UPD_INVENTARIO_DET,
    DEL_INVENTARIO,
    UPD_INVENTARIO,

    //INVENTARIO DETALLE
    RET_INVENTARIO_DET_BY_ID,
    CRE_INVENTARIO_DET,
    DEL_INVENTARIO_DET,


    //ACTIVOS EXCLUSIONES
    RET_ACTIVO_EXCLUSION_BY_ID,
    RET_ACTIVOS_EXCLUSION_BY_EXCLUSION,
    DEL_ACTIVOS_EXCLUSION_BY_ID,
    CRE_ACTIVOS_EXCLUSION,

    //FILE MANAGMENT        
    RET_FILES_BY_OWNER_ID,
    DEL_FILE_BY_OF_ID,
    RET_REF_FILES_BY_OWNER_ID,
    RET_FILE_BY_ID,

    // NODES
    RET_NODES,
    RET_ALL_NODES,
    UPD_NODE_BY_ID,
    DEL_NODE_BY_ID,

    // NODE_ROLE
    RET_NODES_BY_ROLE,
    DEL_NODE_BY_ROLE,

    // NODE_ACESS
    RET_NODES_ACCESS,
    CRE_NODES_ACCESS,
    DEL_NODES_ACCESS,

    //SMS REPLIES
    RET_MAX_UPDATE_DATE,
    RET_POSSIBLE_REPLY,

    //OBJETOS CLIENTES
    RET_OBJETOS_BY_CLIENTE_TOMADOR,
    RET_OBJETOS_BY_CLIENTE_ASEG,
    RET_PROD_BY_CLIENTE_ASEG,
    RET_POLIZAS_BY_TOMADOR,
    RET_OBJ_CLIENTE,

    //DESIGNADOS
    RET_DESIGNADOS_BY_DOC,
    CRE_DESIGNADO,
    DEL_DESIGNADO_BY_ID,
    RET_DESIGNADOS_BY_OBJETO,
    DEL_ALL_DESIGNADOS,

    //CATALOGO DE OBJETOS
    RET_CATALOGO_POLIZAS,
    RET_CATALOGO_POLIZAS_50,

    //MUTUAL
    RET_DESIGNACION_ENC_MUTUAL,
    RET_DESIGNACION_DET_MUTUAL,

    //POLIZA
    RET_POLIZA_BY_NUM_OBJETO,
    UPD_POLIZA,

    //DEPENDIENTE
    RET_DEPENDIENTE_BY_NUMCLIENTE,
    DEL_DEPENDIENTE_BY_ID,
    CRE_DEPENDIENTE,
    RET_DEPENDIENTE_BY_ID,

    //DEPENDIENTE POLIZAS
    RET_DEPENDIENTES_BY_NUMOBJETO,
    DEL_DEPENDIENTE_POLIZA,

    //ENTES
    RET_CATALOGO_ENTES_P_SEG_SME,
    RET_CATALOGO_ENTES_P_SEG_AES,
    RET_CATALOGO_ENTES_P_SEG_AGF,
    RET_CATALOGO_ENTES_P_SEG_SMI,
    RET_CATALOGO_ENTES,

    //PAISES
    RET_CATALOGO_PAISES,
    //PRACTICANTES
    RET_USER_BY_ID_Prac_David,
    RET_CLIENTE_BY_ID_DOUGLAS,
    UPD_USERS_PRAC_DAVID,
    UPD_USERS_PRUEBA_DOUGLAS,
    CRE_USERS_PRAC_DAVID,

    //TABLAS_VALORES
    RET_VALORES_LST_C2190510_TAB250,
    RET_VALORES_LST_C2190520_TAB260,
    RET_VALORES_LST_C2190540_TAB270,
    RET_VALORES_LST_C2190550_TAB1140,
    RET_VALORES_LST_C2190560_TAB1140,

    //SME INTEGRAL
    RET_VALORES_LST_C5313320_TAB260,
    RET_VALORES_LST_C5313340_TAB270,
    RET_VALORES_LST_C5313310_TAB250,
    RET_VALORES_LST_C5313180_TAB1140,


    //CATALOGO
    CRE_CATALOGO_REQ_PRY,
    UPD_CATALOGO_REQ_PRY,
    RET_CATALOGO_REQ_PRY_BY_FILTERS,
    RET_CATALOGO_REQ_PRY,
    DEL_CATALOGO_REQ_PRY,
    RET_CATALOGO_REQ_PRY_BY_TIPO,
    RET_CATALOGO_REQ_PRY_PROY,
    RET_CATALOGO_REQ_PRY_REQ,
    CRE_BITACORA_ACTIVIDADES,
    UPD_BITACORA_ACTIVIDADES,
    RET_BITACORA_ACTIVIDADES_BY_ID,
    RET_BITACORA_ACTIVIDADES,
    DEL_BITACORA_ACTIVIDADES,
    RET_BITACORA_BY_TAREA,

    //TIQUETES
    CRE_SCTI_TIQUETE,
    RET_TIQUETES_PREREGISTRADOS,
    RET_USUARIOS_SISTEMAS_POR_FILTROS,
    RET_USUARIOS_SISTEMAS,
    CRE_USUARIOS_SISTEMAS,
    UPD_USUARIOS_SISTEMAS,
    DEL_USUARIOS_SISTEMAS,
    CRE_DEPARTAMENTO_TIQUETE,
    UPD_DEPARTAMENTO_TIQUETE,
    RET_DEPARTAMENTO_TIQUETE,
    RET_DEPARTAMENTO_TIQUETE_POR_FILTROS,
    RET_DEPARTAMENTO_TIQUETE_ES_DEPTO,
    RET_DEPARTAMENTO_TIQUETE_ES_DIR,
    DEL_DEPARTAMENTO_TIQUETE,
    RET_SERVICIOS_TI,
    RET_PROCESOS_NEGOCIO,
    RET_PROCESOS_NEGOCIO_TIQUETE_POR_FILTROS,
    DEL_PROCESOS_NEGOCIO_TIQUETE,
    UPD_PROCESOS_NEGOCIO_TIQUETE,
    CRE_PROCESOS_NEGOCIO_TIQUETE,
    RET_TIPOS_SOLICITUD_TI,
    RET_USUARIOS_SISTEMAS_BY_COD_USUARIO,
    RET_SERVICIOS_TIQUETE_POR_FILTROS,
    DEL_SERVICIOS_TIQUETE,
    UPD_SERVICIOS_TIQUETE,
    CRE_SERVICIOS_TIQUETE,
    RET_DEPARTAMENTO_TIQUETE_BY_ID,
    UPD_TIQ_PREREGISTRADOS,
    DEL_TECNICO_TI,
    CRE_TECNICO_TI,
    RET_TECNICO_TI_POR_FILTROS,
    UPD_TECNICO_TI,
    DEL_TIQ_PREREGISTRADOS,
    CRE_AREA_TI,
    UPD_AREA_TI,
    RET_AREA_TI_POR_FILTROS,
    DEL_AREA_TI,
    UPD_TIQUETE_SC_BY_ID,
    RET_AREA_TI,
    RET_TIPO_SOLICITUD_TI_POR_FILTROS,
    CRE_TIPO_SOLICITUD_TI,
    UPD_TIPO_SOLICITUD_TI,
    DEL_TIPO_SOLICITUD_TI,
    RET_AREA_TI_EXISTE,
    RET_TECNICO_TI_EXISTE,
    RET_TIQUETES_RESUELTOS,
    CRE_ENCUESTA_TI,
    RET_TIQUETES_SEGUIMIENTO,
    RET_DETALLE_TIQUETE_BY_ID,
    RET_AREA_TI_ESTADO,
    CRE_FORM_USUARIO,
    DEL_FORM_USUARIO,
    RET_FORM_USUARIO,
    UPD_FORM_USUARIO,
    RET_FORM_USUARIO_POR_TIQ,
    RET_USUARIO_SISTEMA_CLASF_DEPTO,
    RET_FORM_USUARIO_EXISTE,
    RET_SOLUCION_TIQUETES_BY_ID,
    UPD_TIQ_EST,
    UPD_TIQ_EST_SUSP,
    UPD_TIQ_EST_CANC,
    UPD_TIQ_IND_CIERRE,
    RET_ENCUESTA_TI_BY_ID,
    DEL_TIQUETE,
    RET_TECNICO_TI,
    RET_TIQUETES_POR_ESTADO,
    CRE_SCTI_DET_TIQUETE,
    CRE_SOLUCION_INC,
    UPD_TIQ_CATEGORIZAR,
    RET_DETALLE_TIQUETE_BY_ATENCION,
    UPD_ESTADO_DETALLE_TI,
    DEL_DETALLE_TIQUETE_SC_BY_ID,
    RET_TRASLADOS_BY_ID_TIQ,
    UPD_DET_TIQUETE_DESC_SOLUCION_TAREA,
    RET_MAX_ID_HIST_SC_BY_ID,
    CRE_HIST_TIQUETE_SC,
    RET_CANTIDAD_TAREAS_POR_TECNICO,
    RET_DETALLE_TIQUETE_BY_COD_USUARIO_TECNICO,
    RET_TIQUETES_POR_ID,
    RET_ENC_TIQUETE_BY_COD_TECNICO,
    UPD_TIQ_ORDEN_ATENCION,
    UPD_DET_TIQUETE,
    CRE_SCTI_BITACORA_TAREA_SC,
    RET_BITACORA_TAREA_BY_ID_TECNICO,
    UPD_LIST_EST_DETALLE_TI,
    DEL_SERVICIOS_PROCESOS,
    CRE_SERVICIOS_PROCESOS,
    DEL_SERVICIOS_TIP_SOL,
    CRE_SERVICIOS_TIP_SOL,
    DEL_TIPOS_SERVICIOS,
    CRE_TIPOS_SERVICIOS,
    RET_TIPOS_SERVICIOS_BY_SERVICE,
    RET_VALIDAR_EXISTE,
    RET_TODOS_DEP_FORM_POR_EMPRESA_SSVMN,
    RET_TODOS_DEP_FORM_POR_EMPRESA_SM,
    RET_TIPOS_SERVICIOS_BY_TIPO,
    RET_TODOS_TIQUETES,
    RET_HISTORICO_POR_ID_TIQ,
    CRE_REFERENCIA_DET,
    RET_REFERENCIA_DET,
    RET_REFERENCIA_DET_BY_ID_TIQ,
    UPD_REFERENCIA_DET,
    DEL_REFERENCIA_DET,
    RET_TAREAS_SIN_TERMINAR,
    CRE_HIST_REGISTRADO,
    CRE_TRASLADO_TAREA,
    RET_DETALLE_BY_SUSPENSION,
    UPD_DESC_SUSPENSION,
    RET_HISTORICO_POR_ID_ASIG,
    RET_TIQUETES_BUSQUEDA_VISUALIZACION,
    CRE_DEPTO_CALI,
    DEL_DEPTO_CALI,
    UPD_DEPTO_CALI,
    RET_DEPTO_CALI,
    RET_TIQUETES_POR_SERVICIO,
    RET_TIQUETES_POR_PROCESO,
    RET_TIQUETES_POR_TIPO_SOL,
    RET_TIQUETES_POR_DEPARTAMENTO,
    RET_SERVICIO_POR_PROCESO,
    RET_SERVICIO_POR_SOL,
    RET_TECNICO_TI_POR_AREA,
    RET_TIQUETES_POR_USUARIO,
    CRE_NUEVO_DEPARTAMENTO,
    UPD_DEPARTAMENTO_POR_NUM_DEPTO,
    RET_DETALLE_TIQUETE_BY_ID_ASIGNACION,
    RET_SERVICIOS_TIQ,
    RET_TIQUETES_ZABBIX,
    RET_BUSQUEDA_TIQUETES_ZABBIX,
    RET_TIQUETES_POR_ID_ZABBIX,
    UPD_TIQ_AGRUPAR,
    UPD_TIQ_PADRE,
    RET_TIQUETES_ESTADO_ZABBIX,
    RET_TIQUETES_HIJOS_POR_ID_PADRE,
    UPD_TIQ_EST_ZB,
    RET_BUSQUEDA_TIQ_ZB,
    RET_TIQUETES_POR_ESTADO_ZB,
    UPD_TIQ_HIJO,

    //DESPLIEGUES
    CRE_ENC_DESPLIEGUE,
    RET_ENC_DESPLIEGUE,
    UPD_ENC_DESPLIEGUE,
    DEL_ENC_DESPLIEGUE,
    RET_BUSCAR_ENC_DESPLIEGUE,
    RET_ALL_OBJ_DICTIONARY,
    RET_ITEMS_BY_ID_CATEGORY,
    RET_ALL_CATEGORY_AT,
    CRE_DEPLOY_CATEGORY,
    RET_DEPLOY_CATEGORY,
    DEL_DEPLOY_CATEGORY,
    UPD_DEPLOY_CATEGORY,
    RET_DET_DEPLOY_ITEM,
    RET_ITEMS_BY_DEPLOY_ID,
    RET_ITEM_BY_ID,
    UPD_ITEM_BY_ID,
    DEL_ITEM_BY_ID,
    RET_MAX_DEP_ORDER,
    RET_OBJ_DICTIONARY,
    CRE_OBJ_DICTIONARY,
    UPD_OBJ_DICTIONARY,
    DEL_OBJ_DICTIONARY,
    RET_EXIST_OBJ_REMOVE,
    CRE_OBJ_REMOVE,
    UPD_OBJ_REMOVE,
    DEL_OBJ_REMOVE,
    RET_OBJ_REMOVE_BY_FILTER,
    RET_HISTORY_OBJS_REMOVE,
    RET_HISTORY_BY_DEPLOY_ID,
    RET_ENC_DESPLIEGUE_BY_ID,
    RET_NEXT_CATEGORY,
    RET_CATEGORIES_NO_STATUS,
    CRE_HISTORY_BY_DEPLOY,
    RET_HISTORY_EXIST,
    RET_ALL_OBJ_DICTIONARY_SIGMA_ORA_FORMS,
    RET_ALL_OBJ_DICTIONARY_SIGMA_ORA_REPORTS,
    RET_DEPLOYMENT_DDL,
    RET_DEPLOYMENT_DML,
    RET_CATEGORY_BY_ID,
    UPD_ITEMS_BY_DEPLOY_CATEGORY,
    RET_ALL_HOST_BY_CATEGORY_ID,
    RET_MAX_ORDER,
    RET_ALL_ITEM_BY_STATUS,
    RET_CATEGORY_BY_TYPE,
    RET_ALL_OBJ_BY_CATEGORY_ID,
    RET_OBJECT_BY_NOM_OBJ,
    RET_CATEGORY_BY_COMPOSITION,


    //DETALLE DESPLIEGUE
    CRE_DET_DESPLIEGUE,

    //SOLICITUD CONTRASEÑAS
    RET_TIPO_SOL_PWD,
    CRE_SOLICITUD_PWD,
    RET_SOL_PWD_REGISTRADO,
    UPD_SOL_PWD,
    RET_SOL_PWD_BY_ID,
    DEL_SOL_PWD_BY_ID,
    RET_SOLICITUD_PWD,

    //PASES PRODUCCION
    CRE_DEPLOYEMENT_POINTS_SC,
    RET_DEPLOYEMENT_POINTS_SC,
    UPD_DEPLOYEMENT_POINTS_SC,
    DEL_DEPLOYEMENT_POINTS_SC,
    UPD_AT_HOST_BY_ID_HOST,
    RET_AT_HOST_BY_ID_HOST,
    RET_AT_DEPLOYEMENT_POINTS_BY_FILTER,
    RET_AT_HOST_BY_CATEGORY_ID,
    CRE_AT_HOST_SC,
    RET_AT_HOST_SC_BY_CATEGORY_ID,
    DEL_AT_HOST_BY_ID_HOST,
    RET_AT_ACTION_SC_BY_CODE,
    CRE_AT_ACTION_SC,
    UPD_AT_ACTION_SC_BY_CODE,
    DEL_AT_ACTION_SC_BY_CODE,
    RET_ALL_ACTION_BY_CATEGORY_ID,
    RET_CATEGORY_BY_DEPLOY,

    //ACCESS SIGMA
    RET_ACCESS_SIGMA,
    CRE_ACCESS_SIGMA,
    UPD_ACCESS_BY_ID,
    RET_ACCESS_SIGMA_BY_ID,
    DEL_ACCESS_SIGMA_BY_ID,
    RET_ACCESS_SIGMA_BY_SEARCH,

    //AUTH_USERS
    RET_AUTH_USERS_BY_ID,
    RET_AUTH_USERS,
    RET_USER_AUTHORIZED,
    UPD_AUTH_USERS,
    DEL_AUTH_USERS,
    RET_NOM_USUARIO_POR_CODIGO,

    //PUESTOS
    RET_PUESTOS_RH,
    RET_PUESTOS_POR_DEPARTAMENTO,
    RET_PUESTOS_BY_NUM_CLIENTE,
    RET_PUESTOS,

    //ENC_CART_PF
    RET_ALL_ENC_CART,
    RET_ENC_CART_BY_OWNER,
    CRE_ENC_CART,
    DEL_ENC_CART,
    UPD_ENC_CART,

    //ENT_CART_PAYMENT
    RET_ENC_CART_PAYMENT,
    UPD_ENT_CART_PAYMENT,

    //ENT_CART_PAYMENT_DETAIL
    RET_CART_PAYMENT_DETAIL,
    UPD_CART_PAYMENT_DETAIL,

    //AGENTES
    RET_AGENTE_BY_NUMCLIENTE,

    //PLANILLA PATRONOS REC

    RET_DET_PLANILLA_REC,
    UPD_DET_PLANILLA_REC,
    DEL_DET_PLANILLA_REC,
    CRE_DET_PLANILLA_REC,
    RET_ENC_PLANILLA_REC,
    UPD_ENC_PLANILLA_REC,
    DEL_ENC_PLANILLA_REC,
    CRE_ENC_PLANILLA_REC,
    RET_DET_PLAN_ASOCIADO,
    RET_ASOCIADOS_ELIMINADOS,

    //DET_CRITERIOS
    RET_DET_CRITERIO_01,
    RET_DET_CRITERIO_02,
    RET_DET_CRITERIO_03,
    RET_DET_CRITERIO_04,
    RET_DET_CRITERIO_05,
    RET_DET_CRITERIO_06,
    RET_DET_CRITERIO_07,
    RET_DET_CRITERIO_08,
    RET_DET_CRITERIO_09,
    RET_DET_CRITERIO_10,
    RET_DET_CRITERIO_11,
    RET_DET_CRITERIO_12,
    RET_DET_CRITERIO_13,
    RET_DET_CRITERIO_14,
    RET_DET_CRITERIO_15,
    RET_DET_CRITERIO_16,
    RET_DET_CRITERIO_17,
    RET_DET_CRITERIO_18,
    RET_DET_CRITERIO_19,
    RET_DET_CRITERIO_20,
    RET_DET_CRITERIO_21,
    RET_DET_CRITERIO_22,

    //DET_FORMULARIO_TEMP
    UPD_DET_FORMULARIO_TEMP,

    //MgReports
    RET_MG_REPORTS_POR_FILTROS,
    RET_MG_TEST_CASES_POR_REPORT_CODE,
    RET_MG_HIST_REPORTS_POR_REPORT_CODE,
    RET_MG_HINT_CODE_POR_FILTROS,
    UPD_MG_REPORTS,
    CRE_MG_HIST_REPORTS,
    RET_MG_TEST_CASES_BY_REP_COD_AND_ROWNUM,
    RET_MG_TEST_CASES_PORCENTAJE_COMPARADOS,
    UPD_MG_TEST_CASES,
    RET_MG_REPORTS_POR_COMPLEX,
    RET_USER_KEY,

    //HIS_CONTACTO
    RET_HISTORICO_POR_CLIENTE,
    DEL_HISTORICO_POR_ID,

    //HIS_CONTACTO_MV
    RET_HISTORICO_MV_POR_CLIENTE,

    //ENT_LOCA_CLIENTES_CL_MV
    RET_CLIENTE_BY_LOCALIZACION,

    //EJECUCIONES
    RET_EJECUCIONES_BY_EJECUCION,
    RET_MIN_EJECUCION,

    //NOTIFICATION
    RET_NOTIFICATIONS_BY_USER,
    UPD_NOTIFICATION_STATUS,
    CRE_NOTIFICATION,

    //OPERATION_TRACKING_PF
    RET_LIST_OPERATIONS,

    //OPERATION_HIST_PF
    RET_LIST_HIST,

    //OPERATION_QUEUE_PF
    RET_LIST_QUEUE,
    CRE_LIST_QUEUE
}